
class LanguageSelectorControl {

  languages = ['fr', 'ar'];

  onAdd(map) {
    this.language = 'fr';
    this.map = map;
    const self = this;
    const buttons = [];

    this.container = document.createElement('div');
    this.container.classList.add('mapboxgl-ctrl', 'mapboxgl-ctrl-group', 'mapboxgl-ctrl-lang');

    this.languages.forEach(lang => {

      const button = document.createElement('button');
      if ('fr' === lang) button.classList.add('visible');
      button.textContent = lang;

      button.addEventListener('click', function() {
        if (button.classList.contains('active')) return;
        self.language = button.textContent;
        self.updateLanguage();

        buttons.forEach(b => b.classList.remove('active'))
        buttons.forEach(b => b.classList.remove('visible'))
        button.classList.add('active');
      });

      buttons.push(button);
      self.container.appendChild(button);
    });

    map.on('style.load', this.updateLanguage.bind(this));

    return this.container;
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this.map = undefined;
  }

  updateLanguage() {
    this.map.getStyle().layers.forEach(layer => {
      if ('symbol' === layer.type) {

        const defaultLabel = this.map.getLayoutProperty(layer.id, 'text-field');

        if (defaultLabel && JSON.stringify(defaultLabel).match(/(?:\bname|\bref)/)) {
          let label;
          switch (this.language) {
            // _xx (mapbox) and :xx (osm) 
            case 'fr': label = ['coalesce', ['get', 'name_fr'], ['get', 'name:fr'], ['get', 'name']]; break;
            case 'ar': label = ['coalesce', ['get', 'name_ar'], ['get', 'name:ar'], ['get', 'name']]; break;
            default: label = ['get', 'name'];
          }

          this.map.setLayoutProperty(layer.id, 'text-field', label);
        }
      }
    });
  }
}

export default LanguageSelectorControl;